import { Fragment, useEffect, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import AuthServices from "../../services/Auth.services";
import { useForm } from "react-hook-form";
import ToastService from "../../services/Toast.Service";
import Cookies from "js-cookie";

export default function TwoFactorInputModal({ isopen, customFn, getUser }) {
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);

  useEffect(() => {
    setOpen(isopen);
  }, [isopen]);

  useEffect(() => {
    if (open === false) {
      customFn();
    }
  }, [open]);

  const {
    register,
    handleSubmit,
    setError,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: "",
    },
  });

  const onSubmit = (data) => {
    getUser(data);
  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <ExclamationCircleIcon
                          className="h-6 w-6 text-red-500"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-lg leading-6 font-medium text-gray-900"
                        >
                          Vul uw 2FA code in!
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            U heeft 2FA ingesteld op dit profiel, vul de code
                            die in uw authenticator staat in om verder te gaan.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="olafGrid space-y-4"
                    id="twoFA-form"
                  >
                    <div className="flex flex-col">
                      <div className="mt-2 bg-white px-4 py-5 rounded-tl-lg rounded-br-lg space-y-6">
                        <div className="flex items-center">
                          <div className="ml-4 w-full flex items-center">
                            <div className="w-full">
                              <input
                                type="text"
                                {...register("code", {
                                  required: true,
                                })}
                                placeholder="Code*"
                                id="code"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                  errors.code
                                    ? "border-red-500"
                                    : "border-white"
                                }`}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <div className="ml-4 w-full flex items-center">
                            <div className="w-full">
                              <input
                                hidden={true}
                                type="text"
                                {...register("profileId", {
                                  required: false,
                                })}
                                placeholder="ProfileId"
                                id="profileId"
                                className={`bg-[#F6F5F3] w-full h-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none ${
                                  errors.code
                                    ? "border-red-500"
                                    : "border-white"
                                }`}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                      type="submit"
                      form="twoFA-form"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-800 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                      Aanmelden
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => setOpen(false)}
                      ref={cancelButtonRef}
                    >
                      Terug
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
